/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_KeepInputs */

const en_orders_keep = /** @type {(inputs: Orders_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep`)
};

const es_orders_keep = /** @type {(inputs: Orders_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conservar`)
};

/**
* | output |
* | --- |
* | "Keep" |
*
* @param {Orders_KeepInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_keep = /** @type {((inputs?: Orders_KeepInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_KeepInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_keep(inputs)
	return es_orders_keep(inputs)
});